import React, { useState } from 'react';
import { motion } from 'framer-motion';
type PlanKey = 'basico' | 'pareja' | 'familia' | 'completo';
const PLANS: {
  key: PlanKey;
  emoji: string;
  name: string;
  subtitle: string;
  items: string[];
  extraItems?: string[];
  oldPrice: string;
  price: string;
  checkoutUrl: string;
  badge?: string;
  saveBadge?: string;
  isVip?: boolean;
}[] = [{
  key: 'basico',
  emoji: '📘',
  name: 'PACK BÁSICO',
  subtitle: '4 libros + 400 citas + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  oldPrice: '$19.97',
  price: '$9.97',
  checkoutUrl: 'https://checkout.tiempodefamilia.com/cart/50159213117797:1'
}, {
  key: 'pareja',
  emoji: '💑',
  name: 'PACK PAREJA',
  subtitle: 'Pack Básico + 100 Citas en Pareja + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  extraItems: ['+ 💑 100 Citas en Pareja'],
  oldPrice: '$25.97',
  price: '$12.97',
  checkoutUrl: 'https://checkout.tiempodefamilia.com/cart/50200106664293:1'
}, {
  key: 'familia',
  emoji: '👨‍👩‍👧',
  name: 'PACK FAMILIA',
  subtitle: 'Pack Básico + 100 Citas en Familia + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  extraItems: ['+ 👨‍👩‍👧 100 Citas en Familia'],
  oldPrice: '$25.97',
  price: '$12.97',
  checkoutUrl: 'https://checkout.tiempodefamilia.com/cart/50200106631525:1'
}, {
  key: 'completo',
  emoji: '🏆',
  name: 'PACK COMPLETO',
  subtitle: '6 libros + 600 citas + bonos',
  items: ['📘 100 Citas Mamá e Hija', '📗 100 Citas Mamá e Hijo', '📙 100 Citas Papá e Hija', '📕 100 Citas Papá e Hijo'],
  extraItems: ['+ 💑 100 Citas en Pareja', '+ 👨‍👩‍👧 100 Citas en Familia'],
  oldPrice: '$37.97',
  price: '$15.97',
  checkoutUrl: 'https://checkout.tiempodefamilia.com/cart/50200106762597:1',
  badge: '⭐ Más elegido',
  saveBadge: 'Mejor valor',
  isVip: true
}];
export function PricingSection() {
  const [selected, setSelected] = useState<PlanKey>('completo');
  const currentPlan = PLANS.find(p => p.key === selected)!;
  return <section id="pricing" className="py-20 px-4 bg-[#111111] scroll-mt-10" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-109">
          <div className="text-center mb-10" data-id="element-110">
            <h2 className="text-4xl md:text-6xl font-black text-white mb-4 uppercase tracking-tight" data-id="element-111">
              🛒 ELEGÍ TU PLAN Y EMPEZÁ HOY
            </h2>
            <p className="text-lg text-gray-400 font-medium" data-id="element-112">
              Descarga inmediata. Acceso de por vida. Los recuerdos no esperan.
            </p>
            <p className="text-sm md:text-base text-yellow-400 font-bold mt-2" data-id="element-113">
              💳 Pagalo en tu moneda local
            </p>
            <p className="text-white font-bold text-base md:text-lg mt-4 animate-bounce" data-id="element-114">
              👇 Elegí tu plan y dale a COMPRAR AHORA 👇
            </p>
          </div>

          <div className="space-y-3 mb-8" data-id="element-115">
            {PLANS.map(plan => {
            const isSelected = selected === plan.key;
            const isVip = plan.isVip;
            return <button key={plan.key} onClick={() => setSelected(plan.key)} className={`w-full rounded-2xl p-4 md:p-5 flex items-start gap-3 md:gap-4 transition-all duration-300 cursor-pointer text-left relative overflow-hidden ${isSelected ? isVip ? 'bg-gradient-to-br from-[#1a1a00] via-[#1a1500] to-[#1a1a00] border-2 border-yellow-400 shadow-[0_0_40px_rgba(250,204,21,0.25)]' : 'bg-[#1a1a1a] border-2 border-gray-500' : 'bg-[#1a1a1a] border-2 border-[#2a2a2a] opacity-60 hover:opacity-85'}`} data-id="element-116">
                  {/* VIP top accent */}
                  {isVip && isSelected && <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-300 to-yellow-600" data-id="element-117"></div>}

                  {/* Radio */}
                  <div className={`w-5 h-5 mt-1 rounded-full border-2 flex-shrink-0 flex items-center justify-center transition-colors ${isSelected ? isVip ? 'border-yellow-400' : 'border-white' : 'border-gray-600'}`} data-id="element-118">
                    {isSelected && <div className={`w-2.5 h-2.5 rounded-full ${isVip ? 'bg-yellow-400' : 'bg-white'}`} data-id="element-119" />}
                  </div>

                  {/* Info */}
                  <div className="flex-1 min-w-0" data-id="element-120">
                    <div className="flex items-center gap-2 mb-1 flex-wrap" data-id="element-121">
                      <span className="text-lg" data-id="element-122">{plan.emoji}</span>
                      <h3 className={`text-base md:text-lg font-black uppercase tracking-wide ${isVip ? 'text-yellow-400' : 'text-white'}`} data-id="element-123">
                        {plan.name}
                      </h3>
                    </div>

                    {/* Badges */}
                    {(plan.badge || plan.saveBadge) && <div className="flex flex-wrap items-center gap-1.5 mb-1.5" data-id="element-124">
                        {plan.badge && <span className="inline-flex items-center gap-1 bg-gradient-to-r from-yellow-500 via-amber-400 to-yellow-500 text-black text-[10px] md:text-xs font-black px-2 py-0.5 rounded-full uppercase tracking-wider shadow-md" data-id="element-125">
                            {plan.badge}
                          </span>}
                        {plan.saveBadge && <span className="inline-flex items-center text-yellow-400 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full border border-yellow-400/50 uppercase tracking-wider bg-yellow-400/10" data-id="element-126">
                            {plan.saveBadge}
                          </span>}
                      </div>}

                    <p className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-127">
                      {plan.subtitle}
                    </p>

                    {/* Expandable details when selected */}
                    {isSelected && <div className="flex flex-col gap-0.5 mt-2" data-id="element-128">
                        {plan.items.map((item, i) => <p key={i} className="text-[11px] md:text-xs text-gray-400" data-id="element-129">
                            {item}
                          </p>)}
                        {plan.extraItems?.map((item, i) => <p key={`extra-${i}`} className={`text-xs md:text-sm font-bold ${isVip ? 'text-yellow-300' : 'text-blue-300'}`} data-id="element-130">
                            {item}
                          </p>)}
                      </div>}
                  </div>

                  {/* Price */}
                  <div className="text-right flex-shrink-0 pt-0.5" data-id="element-131">
                    <p className="text-[11px] md:text-sm text-gray-500 line-through font-medium" data-id="element-132">
                      {plan.oldPrice}
                    </p>
                    <p className={`text-2xl md:text-3xl font-black ${isVip && isSelected ? 'text-yellow-400' : 'text-white'}`} data-id="element-133">
                      {plan.price}
                    </p>
                  </div>
                </button>;
          })}
          </div>

          {/* Persuasive nudge for Pack Completo */}
          <div className="bg-gradient-to-r from-yellow-400/10 to-yellow-400/5 border border-yellow-400/30 rounded-xl p-4 mb-6 text-center" data-id="element-134">
            <p className="text-yellow-400 font-bold text-sm md:text-base mb-1" data-id="element-135">
              💡 ¿Por qué el 70% de los padres eligen el Pack Completo?
            </p>
            <p className="text-gray-300 text-xs md:text-sm leading-relaxed" data-id="element-136">
              Porque no solo fortalecés el vínculo con tus hijos, sino también{' '}
              <span className="text-white font-bold" data-id="element-137">
                con tu pareja y toda la familia
              </span>
              . Son{' '}
              <span className="text-yellow-400 font-bold" data-id="element-138">200 citas extra</span>{' '}
              por la mejor relación calidad-precio. Dentro de unos años vas a
              agradecer haber creado estos momentos.{' '}
              <span className="text-yellow-400 font-bold" data-id="element-139">
                No dejes pasar esta oportunidad.
              </span>
            </p>
          </div>

          {/* Checkout CTA */}
          <a href={currentPlan.checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-140">
            <motion.div whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="relative w-full group" data-id="element-141">
              <div className="absolute -inset-1 bg-gradient-to-r from-red-600 to-orange-500 rounded-xl blur opacity-70 group-hover:opacity-100 transition duration-200" data-id="element-142"></div>
              <div className="relative w-full flex flex-col items-center justify-center px-6 py-4 bg-gradient-to-b from-red-500 to-red-700 border-b-4 border-red-900 rounded-xl shadow-2xl text-white font-black text-xl md:text-2xl uppercase tracking-wide hover:from-red-400 hover:to-red-600 transition-all" data-id="element-143">
                <div className="flex items-center gap-2 text-center" data-id="element-144">
                  👉 COMPRAR AHORA
                </div>
                <span className="text-sm md:text-base font-medium text-red-100 mt-1 normal-case tracking-normal" data-id="element-145">
                  Descarga inmediata • Garantía de 7 días
                </span>
              </div>
            </motion.div>
          </a>

          <div className="flex items-center justify-center gap-4 mt-6 text-gray-500 text-sm" data-id="element-146">
            <span className="flex items-center gap-1" data-id="element-147">🔒 Pago seguro</span>
            <span data-id="element-148">•</span>
            <span className="flex items-center gap-1" data-id="element-149">
              📥 Descarga inmediata
            </span>
            <span data-id="element-150">•</span>
            <span className="flex items-center gap-1" data-id="element-151">✅ Garantía 7 días</span>
          </div>
        </motion.div>
      </div>
    </section>;
}